

(() => {
  /*============================================================================
    Collection template
    ==============================================================================*/

  var CollectionTemplate = function () {
    var container;

    function CollectionTemplate(element) {
      container = element;
      _classCallCheck(this, CollectionTemplate);


      if (window.theme.infiniteScroll && container && typeof isSettingsObj !== 'undefined') {

        var elem = container.querySelector(isSettingsObj.container);
        if (container.querySelector(isSettingsObj.path)) {
          var infScroll = new InfiniteScroll(elem, {
            path: isSettingsObj.path,
            append: isSettingsObj.append,
            history: false,
            hideNav: isSettingsObj.hideNav,
            status: isSettingsObj.status,
            scrollThreshold: isSettingsObj.scrollThreshold
          });

          infScroll.on('append', function (body, path, items, response) {
            document.body.dispatchEvent(new CustomEvent('infScrollAppend'));

            items.forEach(item => {
              if (item.hasAttribute('data-product-grid-item')) {
                new window.theme.QuickAddProduct(item);
                if (window.OdditProductCard) window.OdditProductCard.init(item);

                let wrap = item.querySelector('[data-grid-swatches]');
                if (wrap) {
                  new window.theme.GridSwatch(wrap, undefined);
                }
              }
            });
          });
        }
      }
    }

    _createClass(CollectionTemplate);

    return CollectionTemplate;
  }();

  window.sections.register('collection', CollectionTemplate);
})();


